<template>
	<v-card class="my-profile-page page" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-skeleton-loader
				v-if="this.isLoading"
				v-bind="attrs"
				type="card"
			/>
			<v-card-text v-else-if="this.profile">	
				<v-card
					class="my-profile-page__section"
					flat
					v-bind:style="{paddingTop: userFlag ? '32px' : '16px'}"
				>
					<ProfileBadge v-if="userFlag" :badge="userFlag" />
					<div class="my-profile-page__info-wrapper">
						<Avatar
							:avatar="avatarPath"
							:size="120"
							border-radius="square"
							class="my-profile-page__avatar mr-4"
						/>

						<div class="my-profile-page__info">
							<h1 class="my-profile-page__info-username">
								{{ userName }}
							</h1>
							<div class="d-flex flex-column">
								<span v-if="companyName" class="my-profile-page__info-company mb-1">
									{{ companyName }}
								</span>
								<span v-if="heldPosition" class="my-profile-page__info-position">
									{{ heldPosition }}
								</span>
								<span v-if="location" class="my-profile-page__info-location">
									<Icon
										type="pin"
										color="var(--location-color)"
										:size="14"
										:pr="4"
									/>
									<span>{{ location }}</span>
								</span>
							</div>
						</div>
					</div>
					<v-btn class="my-profile-page__info-btn elevation-0" @click="toNotesPage">
						Add Note
					</v-btn>
				</v-card>
				<div
					v-for="(section, index) in allowSections"
					:key="index"
					class="my-profile-page__section"
				>
					<h3 class="my-profile-page__section-title">
						{{ section[0].section }}
					</h3>
					<div v-for="(field, fieldIndex) in section" :key="field.field">
						<div v-if="field.type === 'email'" class="my-profile-page__section-text d-flex flex-nowrap align-center">
							<Icon type="email" color="var(--accent-color)" :pr="12" :size="22" />
							<a :href="'mailto:' + field.value" style="text-decoration: none; color: var(--accent-color);">
								{{ field.value }}
							</a>
						</div>
						<div
							v-else-if="field.section === 'Network' && fieldIndex === 0"
							class="my-profile-page__network"
						>
							<a
								v-for="item in networkFields"
								:key="item.field"
								:href="item.value"
								target="_blank"
								class="my-profile-page__network-link"
							>
								<h3 class="my-profile-page__network-title">
									{{ item.title }}
								</h3>
								<div class="d-flex align-center">
									<Icon :size="28" :type="networkFieldType(item.type)" />
									<span class="my-profile-page__network-link-text ml-2">
										{{ item.value }}
									</span>
								</div>
							</a>
						</div>
						<div v-else-if="field.type === 'phone'" class="py-3 d-flex">
							<Icon type="phone" color="var(--accent-color)" :pr="12" :size="22" />
							<a
								@click="copyPhone(field.value)"
								:href="null"
								style="text-decoration: none; color: var(--ceil-detail-text-color)"
							>
								{{ field.value }}
							</a>
						</div>
						<v-card-text v-else-if="field.type === 'html'" v-html="field.value" />
						<div v-else-if="field.section !== 'Network'" class="mb-2">
							<span class="my-profile-page__section-label"> {{ field.title }}: </span>
							<span class="my-profile-page__section-text">
								{{ field.value }}
							</span>
						</div>
					</div>
				</div>

				<v-skeleton-loader width="600" v-bind="attrs" type="card" v-if="false">
				</v-skeleton-loader>
			</v-card-text>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import Avatar from '@/components/Avatar';
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import twitterLogo from '@/assets/images/twitterX-logo.svg'
import ProfileBadge from '@/components/ProfileBadge.vue'

import _ from 'lodash'

export default {
	name: 'ProfilePage',
	mixins: [Block],
	components: {
		PageBlocked,
		Avatar,
		ProfileBadge
	},
	computed: {
		...mapGetters('auth', ['profile', 'isAuthenticated', 'isLoading']),
		...mapGetters('settings', ['user', 'backUser', 'appCore']),
		...mapGetters('app', ['isShowAlert', 'alertMessage']),

		allowSections() {
			return this.profile.private
				.filter((field) => field.value)
				.reduce((acc, current) => {
					if (acc.length === 0 || acc[acc.length - 1][0].section !== current.section) {
						acc.push([current])
					} else {
						acc[acc.length - 1].push(current)
					}
					return acc
				}, [])
		},
		networkFields() {
			return this.profile.private.filter(field => field.section === 'Network' && field.value)
		},
		profileFieldsType() {
			if (!this.user) {
				return 'public'
			}

			const { view_profile_link: viewProfileLink } = this.user

			return this.getTypeFieldsFromUrl(viewProfileLink)
		},
		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},

		// short profile
		location() {
			const { location_profile_row: location = {} } = this.profile
			return location
		},
		userName() {
			const { visible_username: name } = this.profile
			return name
		},
		avatarPath() {
			const { user_logo: userLogo } = this.profile
			return userLogo
		},
		heldPosition() {
			const { third_profile_row: heldPosition } = this.profile
			return heldPosition
		},
		companyName() {
			const { second_profile_row: company } = this.profile
			return company
		},
		userFlag() {
			const { userFlag: flag } = this.profile || {};

			return flag
		},
		userFlag() {
			const { userFlag: flag } = this.profile || {};

			return flag
		},
	},
	methods: {
		...mapActions('app', ['showAlert', 'hideAlert']),
		...mapActions('settings', ['getUserSettings']),

		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		},
		formatUrl(url) {
			if (!url) {
				return ''
			}

			if (!url.startsWith('http://') && !url.startsWith('https://')) {
				if (url.startsWith('www.')) {
					url = 'https://' + url
				} else {
					url = 'https://www.' + url
				}
			}
			return url
		},
		copyPhone(value) {
			if (!this.isShowAlert) {
				const phone = value.replace(/\D/g, '')

				this.$copyText(phone).then(() => {
					const closeTimeout = setTimeout(() => {
						this.hideAlert('')
					}, 3000)

					this.showAlert({ message: 'Phone number copied successfully.', closeTimeout })
				})
			}
		},
		dateCreated(originalDate) {
			return new Date(originalDate * 1000).toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			})
		},
		getTypeFieldsFromUrl(url) {
			const parts = url.split('/')
			return parts[parts.length - 1]
		},
		fieldClass(allowFields, index) {
			if (index === 0 || allowFields[index].section !== allowFields[index - 1].section) {
				return 'mt-8'
			} else if (
				!allowFields[index + 1] ||
				allowFields[index + 1].section !== allowFields[index].section
			) {
				return 'mb-8'
			} else {
				return ''
			}
		},
		networkFieldType(type) {
			if (type === 'url') {
				return 'link'
			} else {
				return type
			}
		},
		toNotesPage() {
			this.$router.push({ name: 'profile-notes' })
		},
	},
	data() {
		return {
			searchIcon,
			twitterLogo,
			successMessage: false,
			errorMessage: false,
			attrs: {
				elevation: 0,
			},
			socialFieldNames: ['user_linkedin', 'user_facebook', 'user_twitter', 'user_custom_url'],
			phoneFieldNames: ['user_work_phone', 'user_cell_phone'],
			pageBlockedName: 'profile',
		}
	},
	created() {
		if (!this.user) {
			this.getUserSettings()
		}
	},
}
</script>

<style lang="scss">
.my-profile-page {
	background-color: transparent !important;

	&__section {
		max-width: 600px;
		border-radius: 10px !important;
		margin-bottom: 8px;
		padding: 16px;
		background-color: #fff;
		font-family: Montserrat, sans-serif;

		& > div:not(:last-child) > a.my-profile-page__network {
			margin-bottom: 12px;
		}

		&-title {
			font-size: 16px;
			font-weight: 700;
			line-height: 19.5px;
			color: #4A4A4A;
			margin-bottom: 12px;
		}

		&-label {
			font-size: 14px;
			font-weight: 700;
			line-height: 17.07px;
			color: var(--accent-color);
			margin-right: 12px;
		}

		&-text {
			font-size: 14px;
			line-height: 17.07px;
			color: #697583;
		}
	}

	&__network {
		a:not(:last-child) {
			margin-bottom: 12px;
		}

		&-link {
			text-decoration: none;
			display: block;

			&-text {
				font-size: 14px;
				line-height: 17.07px;
				color: var(--accent-color);
				width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
			}
		}

		&-title {
			font-size: 14px;
			font-weight: 600;
			line-height: 22px;
			color: #4A4A4A;
			margin-bottom: 4px;
		}
	}

	&__info {
		font-family: Montserrat, sans-serif;
		width: 100%;

		&-wrapper {
			display: flex;
			flex-wrap: nowrap;
			margin-bottom: 20px;
			
			@media (max-width: 480px) {
				flex-direction: column;			
				align-items: center;
			}
		}

		&-username {
			font-size: 24px;
			line-height: 29.26px;
			font-weight: 700;
			color: var(--accent-color);
			margin-bottom: 12px;

			@media (max-width: 480px) {
				margin-top: 12px;
				text-align: center;
			}
		}

		&-company, &-position {
			font-size: 16px;
			line-height: 19.5px;
			color: #4A4A4A;
			width: 100%;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;

			@media (max-width: 480px) {
				text-align: center;
			}
		}

		&-location {
			font-size: 13px;
			line-height: 19.37px;
			font-weight: 500;
			color: var(--location-color);
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
			margin-top: 12px;

			@media (max-width: 480px) {
				justify-content: center;
			}
		}

		&-btn {
			height: 42px !important;
			padding: 0 38px !important;
			font-size: 18px;
			font-weight: 700;
			line-height: 21.94px;
			text-transform: capitalize;
			font-family: Montserrat, sans-serif;
			color: var(--button-secondary-background-color) !important;
			border: 2px solid var(--button-secondary-background-color);
			background-color: var(--button-secondary-color) !important;
			border-radius: 8px;
		}
	}
}
</style>
